import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import linkify from 'vue-linkify'
import Vuelidate from 'vuelidate'
import VueChatScroll from 'vue-chat-scroll'
import moment from 'moment'
import './../router/permission'
declare module 'vue/types/vue' {
  interface VueConstructor {
    logoImg: any
  }
}
Vue.prototype.logoImg = require('./../assets/img/logo.png')
Vue.directive('linkified', linkify)
Vue.prototype.moment = moment
Vue.use(Vuelidate)
Vue.use(VueChatScroll)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
